// extracted by mini-css-extract-plugin
module.exports = {"jenga":"jenga_jenga__8xulF","item":"jenga_item__swDao","top-left":"jenga_top-left__y4HoE","top-right":"jenga_top-right__Hog9E","bottom":"jenga_bottom__gkQti"};